import React, { useEffect } from 'react';

import _ from 'lodash';
import { Div } from 'nexcomponent-ui';
import { useSelector } from 'react-redux';

import {
  principalProductUserDefinedCategoryBreadCrumb,
} from '../../../../Enum/Breadcrumb/PrincipalProductUserDefinedCategoryBreadcrumb';
import { MAPPING_CODE } from '../../../../Enum/MappingCode/MappingCode';
import {
  ROUTER_CONSTANT,
} from '../../../../Enum/RouterConstant/RouterConstant';
import {
  fetchDataApprovalPrincipalProductUserDefinedCategory,
  fetchPrincipalProductUserDefinedCategoryMappingForm,
} from '../../../../Fetch/FetchData/PrincipalProductUserDefinedCategoryData';
import { mappingFormPageStateGroup } from '../../../../Store/StateGroup';
import CancelOverwrite
  from '../../../Organisms/Button/CancelOverwrite/CancelOverwrite';
import MappingForm
  from '../../../Organisms/Form/MappingForm/MappingForm/MappingForm';
import HeaderPageMapping
  from '../../../Organisms/Header/HeaderPageMapping/HeaderPageMapping';
import ModalMapping from '../../../Organisms/Modal/ModalMapping/ModalMapping';

const PrincipalProductUserDefinedCategoryMappingPage = props => {
  const [, list, , mappingForm] = useSelector(mappingFormPageStateGroup);

  useEffect(() => {
    if (_.has(props.location.state, "data")) {
      const first = _.first(list);
      fetchPrincipalProductUserDefinedCategoryMappingForm(
        props.validToken(),
        props.dispatch,
        "principal_product_user_defined_category_id",
        first.id,
        props.location.state.data.principal_product_user_defined_category_id,
        list,
        props.notify,
        () => props.navigate(ROUTER_CONSTANT.PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY.MAPPING)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, props.location.state, props.dispatch, props.validToken]);
  return (
    <Div>
      <ModalMapping
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        listNavigate={ROUTER_CONSTANT.PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY.LIST}
        approveFuc={(data, mappingList, mappingCount) =>
          fetchDataApprovalPrincipalProductUserDefinedCategory(
            props.validToken(),
            data,
            mappingList,
            mappingCount,
            props.notify,
            props.dispatch
          )
        }
        uniqueKey="principal_product_user_defined_category_id"
        nextMapping={(uniqueKey, newId, existId, mappingList) =>
          fetchPrincipalProductUserDefinedCategoryMappingForm(
            props.validToken(),
            props.dispatch,
            uniqueKey,
            newId,
            existId,
            mappingList,
            props.notify,
            () => props.navigate(ROUTER_CONSTANT.PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY.MAPPING)
          )
        }
      />

      <HeaderPageMapping
        title={props.t("PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY:TITLE")}
        listBreadcrumb={principalProductUserDefinedCategoryBreadCrumb(props.t)}
        defaultBreadcrumb={props.t("PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY:MAPPING.TITLE")}
        to={ROUTER_CONSTANT.PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY.LIST}
      />
      <MappingForm
        t={props.t}
        validToken={props.validToken}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey="principal_product_user_defined_category_id"
        mappingCode={MAPPING_CODE.PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY}
        mappingForm={mappingForm}
      />
      <CancelOverwrite
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey="principal_product_user_defined_category_id"
        mappingForm={mappingForm}
        mappingCode={MAPPING_CODE.PRINCIPAL_PRODUCT_USER_DEFINED_CATEGORY}
      />
    </Div>
  );
};

export default PrincipalProductUserDefinedCategoryMappingPage;
